import { ResponsiveContainer } from "recharts";

export function PieChartSkeleton({ height = 300 }: { height?: number }) {
  return (
    <div
      style={{ height }}
      className="w-full flex items-center justify-center rounded-md bg-gray-100"
    >
      <div className="relative w-40 h-40">
        {/* Outer pulsing circle */}
        <div className="absolute inset-0 rounded-full bg-gray-300 animate-pulse" />

        {/* Mimic pie slices */}
        <div className="absolute inset-0 rounded-full border-[12px] border-gray-200 opacity-40" />
        <div className="absolute inset-0 rounded-full border-[12px] border-gray-300 opacity-40 rotate-45" />
        <div className="absolute inset-0 rounded-full border-[12px] border-gray-200 opacity-40 rotate-90" />
      </div>
    </div>
  );
}

export function BarChartSkeleton({ height = 300 }: { height?: number }) {
  return (
    <div
      style={{ height }}
      className="w-full flex items-end justify-between px-6 py-4 rounded-md"
    >
      {[60, 90, 40, 70, 55].map((h, i) => (
        <div
          key={i}
          style={{ height: `${h}%` }}
          className="w-6 rounded bg-gray-300 animate-pulse"
        />
      ))}
    </div>
  );
}

export function ChartLoader({
  type = "pie",
  height = 300,
}: {
  type?: "pie" | "bar";
  height?: number;
}) {
  if (type === "bar") return <BarChartSkeleton height={height} />;
  return <PieChartSkeleton height={height} />;
}
export function ChartWrapper({
  loading,
  type = "pie",
  height = 300,
  children,
}: {
  loading?: boolean;
  type?: "pie" | "bar";
  height?: number;
  children: React.ReactElement;
}) {
  if (loading) return <ChartLoader type={type} height={height} />;
  return (
    <ResponsiveContainer width="100%" height={height}>
      {children}
    </ResponsiveContainer>
  );
}